/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    BrandAndMarketListItem,
    BrandAndMarketListItemFromJSON,
    BrandAndMarketListItemFromJSONTyped,
    BrandAndMarketListItemToJSON,
    GuidIdAndLabel,
    GuidIdAndLabelFromJSON,
    GuidIdAndLabelFromJSONTyped,
    GuidIdAndLabelToJSON,
} from './';

/**
 * 
 * @export
 * @interface SSRRuleListItem
 */
export interface SSRRuleListItem {
    /**
     * 
     * @type {string}
     * @memberof SSRRuleListItem
     */
    id?: string;
    /**
     * 
     * @type {BrandAndMarketListItem}
     * @memberof SSRRuleListItem
     */
    brandAndMarket?: BrandAndMarketListItem;
    /**
     * 
     * @type {Array<GuidIdAndLabel>}
     * @memberof SSRRuleListItem
     */
    suppliers?: Array<GuidIdAndLabel> | null;
    /**
     * 
     * @type {string}
     * @memberof SSRRuleListItem
     */
    description?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRRuleListItem
     */
    ctce?: string | null;
    /**
     * 
     * @type {string}
     * @memberof SSRRuleListItem
     */
    ctcm?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof SSRRuleListItem
     */
    deleted?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRRuleListItem
     */
    disabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof SSRRuleListItem
     */
    allowEdit?: boolean;
}

export function SSRRuleListItemFromJSON(json: any): SSRRuleListItem {
    return SSRRuleListItemFromJSONTyped(json, false);
}

export function SSRRuleListItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): SSRRuleListItem {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
        'brandAndMarket': !exists(json, 'brandAndMarket') ? undefined : BrandAndMarketListItemFromJSON(json['brandAndMarket']),
        'suppliers': !exists(json, 'suppliers') ? undefined : (json['suppliers'] === null ? null : (json['suppliers'] as Array<any>).map(GuidIdAndLabelFromJSON)),
        'description': !exists(json, 'description') ? undefined : json['description'],
        'ctce': !exists(json, 'ctce') ? undefined : json['ctce'],
        'ctcm': !exists(json, 'ctcm') ? undefined : json['ctcm'],
        'deleted': !exists(json, 'deleted') ? undefined : json['deleted'],
        'disabled': !exists(json, 'disabled') ? undefined : json['disabled'],
        'allowEdit': !exists(json, 'allowEdit') ? undefined : json['allowEdit'],
    };
}

export function SSRRuleListItemToJSON(value?: SSRRuleListItem | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'brandAndMarket': BrandAndMarketListItemToJSON(value.brandAndMarket),
        'suppliers': value.suppliers === undefined ? undefined : (value.suppliers === null ? null : (value.suppliers as Array<any>).map(GuidIdAndLabelToJSON)),
        'description': value.description,
        'ctce': value.ctce,
        'ctcm': value.ctcm,
        'deleted': value.deleted,
        'disabled': value.disabled,
        'allowEdit': value.allowEdit,
    };
}


